import { render, staticRenderFns } from "./AppScreen.vue?vue&type=template&id=e8775aba&scoped=true&"
import script from "./AppScreen.vue?vue&type=script&lang=js&"
export * from "./AppScreen.vue?vue&type=script&lang=js&"
import style0 from "./AppScreen.vue?vue&type=style&index=0&id=e8775aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8775aba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8775aba')) {
      api.createRecord('e8775aba', component.options)
    } else {
      api.reload('e8775aba', component.options)
    }
    module.hot.accept("./AppScreen.vue?vue&type=template&id=e8775aba&scoped=true&", function () {
      api.rerender('e8775aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AppScreen.vue"
export default component.exports